<p>
    component from ng-template works!
</p>

<button color="primary" (click)="closeModal($event)">close</button>